<template>
  <div class="sidebar h-full">
    <template v-if="!isPremiumUser">
      <AdController v-if="isDefaultAds" unit="newSidebarSponTop" class="bg-[#f7f8fb] p-6 mb-6 sticky z-1 top-24" />
      <LatestWidget :articles="latestArticles" class="mb-6" />
      <AdController v-if="isDefaultAds" unit="newSidebarTop" class="bg-[#f7f8fb] p-6 mb-6 sticky z-2 top-24" />
      <RecommendationWidget v-if="IS_ONEDIO" :article="item" class="mb-6" />
      <AdController v-if="isDefaultAds" unit="newSidebarSticky" class="bg-[#f7f8fb] p-6 sticky z-3 top-24" />
      <Taboola v-if="hasTaboolaConfig" id="taboola-video-reel-right-rail" mode="videoreel" class="bg-[#f7f8fb] p-6 sticky top-24" />
    </template>
    <template v-else>
      <div class="space-y-4">
        <div class="u-center premium-user bg-[#f7f8fb] py-6 rounded-md">
          <OLink
            :href="`/${PROFILE_PATH}/${item.authors[0].username}`"
            pure
            class="flex items-center text-xl font-semibold leading-24 text-primary-200"
            @click="$analyticsEvent('User', 'User_Engagement', 'action_profile_click')"
          >
            <img v-if="userAvatar" :src="userAvatar" alt="" width="56" height="56" class="mr-4 rounded-full" />
            {{ item.authors[0].name }}
          </OLink>
        </div>
        <InstagramWidget :user="item.authors[0]" />
        <FacebookTimelineWidget :user="item.authors[0]" />
        <TwitterTimelineWidget height="800" :user="item.authors[0]" />
      </div>
    </template>
  </div>
</template>
<script>
import { defineComponent, computed, inject } from '@nuxtjs/composition-api';
import AdController from '~/modules/ads/components/AdController';
import { getCategoryInfoByPath } from '~/modules/category/utils/categoryHelpers';
import RecommendationWidget from '~/modules/article/components/RecommendationWidget';
import LatestWidget from '~/modules/article/components/LatestWidget';
import { getArticleUrl } from '~/modules/common/utils/routingUtils';
import TwitterTimelineWidget from '~/modules/profile/components/TwitterTimelineWidget';
import FacebookTimelineWidget from '~/modules/profile/components/FacebookTimelineWidget';
import InstagramWidget from '~/modules/profile/components/InstagramWidget';
import { IS_ONEDIO, PROFILE_PATH } from '~/constants/config';
import { OLink } from '~/modules/common/components/ui';

export default defineComponent({
  components: {
    InstagramWidget,
    FacebookTimelineWidget,
    TwitterTimelineWidget,
    AdController,
    RecommendationWidget,
    LatestWidget,
    OLink,
    Taboola: () => import(/* webpackChunkName: "taboola" */ '~/modules/ads/components/Taboola.vue'),
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    latestArticles: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const isPremiumUser = computed(() => props.item.tags?.includes('Premium User'));
    const userAvatar = computed(() => props.item.authors?.[0]?.avatar?.resolutions?.standard?.url);
    const getCategoryColor = (path) => getCategoryInfoByPath(path)?.color;
    const adConfig = inject('adConfig');
    const isDefaultAds = adConfig.value?.decidedMode?.value === 'default';
    const hasTaboolaConfig = adConfig.value?.decidedMode?.value === 'onlyCriteo' && adConfig.value?.mode?.scripts?.includes('Taboola');

    return {
      isPremiumUser,
      userAvatar,
      PROFILE_PATH,
      getCategoryColor,
      getArticleUrl,
      isDefaultAds,
      hasTaboolaConfig,
      IS_ONEDIO,
    };
  },
});
</script>
